export default "__VITE_ASSET__CTxE23in__"